import { render, staticRenderFns } from "./basketcounter.vue?vue&type=template&id=fa35ed0c"
import script from "./basketcounter.vue?vue&type=script&lang=js"
export * from "./basketcounter.vue?vue&type=script&lang=js"
import style0 from "./basketcounter.vue?vue&type=style&index=0&id=fa35ed0c&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa35ed0c')) {
      api.createRecord('fa35ed0c', component.options)
    } else {
      api.reload('fa35ed0c', component.options)
    }
    module.hot.accept("./basketcounter.vue?vue&type=template&id=fa35ed0c", function () {
      api.rerender('fa35ed0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/siteheaderstandard/assets/frontend/components/basketcounter.vue"
export default component.exports